/**
 * @file Two-sided toggle switch component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Label from '../Label';

const propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.node,
  labelTip: PropTypes.string,
  offLabel: PropTypes.node.isRequired,
  onLabel: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

const ToggleSwitch = ({
  id,
  name,
  label,
  labelTip,
  offLabel,
  onLabel,
  checked = false,
  onChange,
  className,
  disabled,
}) => {
  const classes = classNames({
    'toggle-switch': true,
    'toggle-switch-on': checked,
    'toggle-switch-disabled': disabled,
    [className]: !!className,
  });

  return (
    <div className="form-group">
      {/* The heading is deliberately not tied to the input: its tooltip opens
          on click, and a <label for> would toggle the switch along with it. */}
      {label && <Label id={`${id}-label`} label={label} labelTip={labelTip} />}

      <div className={classes}>
        <span className="toggle-switch-label" aria-hidden="true">
          {offLabel}
        </span>

        <input
          className="toggle-switch-input"
          id={id}
          name={name}
          type="checkbox"
          role="switch"
          checked={checked}
          disabled={disabled}
          aria-label={checked ? onLabel : offLabel}
          onChange={event => onChange(event.target.checked)}
        />
        <label className="toggle-switch-track" htmlFor={id}>
          <span className="toggle-switch-thumb" />
        </label>

        <span className="toggle-switch-label" aria-hidden="true">
          {onLabel}
        </span>
      </div>
    </div>
  );
};

ToggleSwitch.propTypes = propTypes;

export default ToggleSwitch;
